import '../components/reservation/reservation.css';
import Tab from "../components/reservation/Tab";
import { useSelector } from 'react-redux';
import { currentTab, updateTab } from '../features/tab/tabSlice';
import Rules from '../components/reservation/Rules';
import PickDate from "../components/reservation/PickDate";
import PatientInfo from '../components/reservation/PatientInfo';
import PatientHealthInfo from '../components/reservation/PatientHealthInfo';
import PatientReview from "../components/reservation/PatientReview";

import TrackingCode from "../components/reservation/TrackingCode";
import { useDispatch } from 'react-redux';
import useQueryParams from "../components/reservation/useQueryParams";
import { useEffect, useState } from "react";
import { getDepartmentInfo } from "../api/routes";
import Nav from "../components/Nav";
import Footer from "../components/Footer";

function Reservation() {
  const dispatch = useDispatch();
  const activeTab = useSelector(currentTab);
  const { code, ref } = useQueryParams()
  const [departmentInfo, setDepartmentInfo] = useState();

  useEffect(() => {
    getDepartmentInfo((isOk, data) => {
      if (!isOk) return alert(data.message);

      else return setDepartmentInfo(data)
    })
  }, [])
  useEffect(() => {
    if (code && ref === 'afterPayment') {
      dispatch(updateTab(5))
    }
  }, [code,ref])
  const headings = ['قوانین و مقررات', 'انتخاب تاریخ و ساعت', 'اطلاعات بیمار', 'اطلاعات سلامت', 'تأیید نهایی', 'کد پیگیری'];
  return (
    <>
      <div className='reservation-page'>
      <div className='container'>
        <Nav logo={departmentInfo && departmentInfo[0].logo} />
        <main className="reservation-layout">
          <section className="reservation-card" aria-label="فرم دریافت نوبت">
            <Tab />
            <header className="booking-step-heading"><h2>{headings[activeTab]}</h2></header>
            <div className="booking-body">
            {activeTab === 0 && <Rules />}
            {activeTab === 1 && <PickDate />}
            {activeTab === 2 && <PatientInfo />}
            {activeTab === 3 && <PatientHealthInfo />}
            {activeTab === 4 && <PatientReview />}
            {activeTab === 5 && <TrackingCode />}
            </div>
          </section>
        </main>
      </div>
      <Footer data={departmentInfo && departmentInfo[0]} />
      </div>
    </>
  );
}

export default Reservation;
